module.exports = __webpack_public_path__ + "img/savings-compare.7160843.png";